import { useEffect, useRef } from 'react'

import { inactivityTimer } from '../constant/constant'

export const useTabLocalInactivity = (logoutCallback) => {
  const timerRef = useRef(null)
  const publicRoutes = [
    '/login',
    '/update-password',
    '/verify-email',
    '/reset-success',
    '/maintenance',
  ]

  useEffect(() => {
    const isPublicRoute = publicRoutes.some((route) =>
      window.location.pathname.startsWith(route)
    )

    if (isPublicRoute) return

    const resetTimer = () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      timerRef.current = setTimeout(() => {
        logoutCallback()
      }, inactivityTimer)
    }

    const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart']
    events.forEach((event) => window.addEventListener(event, resetTimer))

    resetTimer()

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer))
      clearTimeout(timerRef.current)
    }
  }, [logoutCallback])
}
